export * as PrilohaDeclaration from './PrilohaDeclaration';
export * as TypUcel from './TypUcel';
export * as ZadostRozhodnuti from './ZadostRozhodnuti';
export * as ZadostStav from './ZadostStav';
